// extracted by mini-css-extract-plugin
export var addButton = "_f8-0";
export var border = "_f8-8";
export var check = "_f8-h";
export var danger = "_f8-6";
export var dropdownContainer = "_f8-1";
export var editModalBody = "_f8-j";
export var footerContainer = "_f8-i";
export var fullWidth = "_f8-a";
export var hide = "_f8-9";
export var icon = "_f8-3";
export var input = "_f8-7";
export var inputFlex = "_f8-b";
export var inputWrapper = "_f8-c";
export var manualFocus = "_f8-5";
export var optionButton = "_f8-4";
export var pillWrapper = "_f8-e";
export var pointer = "_f8-2";
export var showOverflow = "_f8-f";
export var tagsFlex = "_f8-d";
export var xButton = "_f8-g";